<h2 mat-dialog-title *ngIf="!archived">
  {{ 'RECURRENCES.ALERT_TITLE_ARCHIVE' | translate }}
</h2>
<h2 mat-dialog-title *ngIf="archived">
  {{ 'RECURRENCES.ALERT_TITLE_UNARCHIVE' | translate }}
</h2>

<mat-dialog-content>
  <p *ngIf="!archived" [innerHTML]="'RECURRENCES.ALERT_ARCHIVE' | translate"></p>
  <p *ngIf="archived" [innerHTML]="'RECURRENCES.ALERT_UNARCHIVE' | translate"></p>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button mat-dialog-close>
    <span class="button-name" fxHide.xs>{{ 'RECURRENCES.CANCEL' | translate }}</span>
  </button>

  <button mat-button *ngIf="!archived" [mat-dialog-close]="true" cdkFocusInitial>
    <span class="button-name" fxHide.xs>{{ 'RECURRENCES.ARCHIVE' | translate }}</span>
  </button>

  <button mat-button *ngIf="archived" [mat-dialog-close]="false" cdkFocusInitial>
    <span class="button-name" fxHide.xs>{{ 'RECURRENCES.UNARCHIVE' | translate }}</span>
  </button>
</mat-dialog-actions>
